import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import { FeedBack } from "@src/apis/ModularClient";

export class FeedBackService extends BaseService<FeedBack, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService"];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    private rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/feedback";
    this.$broadcastBusinessNameSingular = "feedback";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  addClass(star: number, id: string) {
    let elementId = "";
    for (let i = 1; i <= star; i++) {
      elementId = id + i;
      document.getElementById(elementId).classList.add("selected");
    }
  }

  removeClass(star: number, id: string, rating) {
    let elementId = "";
    if (rating == undefined) {
      rating = 0;
    }
    for (let i = star; i > rating; i--) {
      elementId = id + i;
      document.getElementById(elementId).classList.remove("selected");
    }
  }

  isFeedBackFormDisabled(isLender: boolean, feedBackDTO: FeedBack) {
    if (isLender) {
      if (
        feedBackDTO != null &&
        feedBackDTO.ratingKnowledge != null &&
        feedBackDTO.ratingPresentation != null &&
        feedBackDTO.ratingResponsiveness != null &&
        feedBackDTO.isAnonymous != null &&
        feedBackDTO.hasSpoken != null
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        feedBackDTO != null &&
        feedBackDTO.ratingCustomerService > 0 &&
        feedBackDTO.ratingSpeed > 0 &&
        feedBackDTO.ratingUnderwritingFlexibility > 0 &&
        feedBackDTO.hasSpoken != null &&
        feedBackDTO.isAnonymous != null
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  updateRating(star: number, rating: string, feedBackDTO: FeedBack) {
    switch (rating) {
      case "RatingCustomerService":
        feedBackDTO.ratingCustomerService =
          feedBackDTO != undefined && feedBackDTO.ratingCustomerService == 1 && star == 1 ? 0 : star;
        break;
      case "RatingSpeed":
        feedBackDTO.ratingSpeed = feedBackDTO != null && feedBackDTO?.ratingSpeed == 1 && star == 1 ? 0 : star;
        break;
      case "RatingUnderwritingFlexibility":
        feedBackDTO.ratingUnderwritingFlexibility =
          feedBackDTO != null && feedBackDTO?.ratingUnderwritingFlexibility == 1 && star == 1 ? 0 : star;
        break;
      case "RatingPresentation":
        feedBackDTO.ratingPresentation =
          feedBackDTO != null && feedBackDTO?.ratingPresentation == 1 && star == 1 ? 0 : star;
        break;
      case "RatingResponsiveness":
        feedBackDTO.ratingResponsiveness =
          feedBackDTO != null && feedBackDTO?.ratingResponsiveness == 1 && star == 1 ? 0 : star;
        break;
      case "RatingKnowledge":
        feedBackDTO.ratingKnowledge = feedBackDTO != null && feedBackDTO?.ratingKnowledge == 1 && star == 1 ? 0 : star;
        break;
      default:
        break;
    }

    return feedBackDTO;
  }
}
